module.exports = __webpack_public_path__ + "static/media/icon_mastercard.51e5d1cc.svg";